export default __webpack_public_path__ + "static/kb_3_19-c4c03f49f13cac5bf9fbf802a3f9ae05.jpg";